import IntroFlow from '../../../screens/animations/introFlow';

export const INTRO_SCREENS = [
    {
        key: 'intro',
        trackingName: 'diagnostic',
        screenName: 'intro',
        component: <IntroFlow />
    }
];
